<!--

============================================================================================================
||    PageTitle component                                                                                 ||
============================================================================================================

|   Description
------------------------------------------------------------------------------------------------------------
Component is used for all the main titles on each page. It can have a icon/image as prefix and
a description as subtext.

|   Props
------------------------------------------------------------------------------------------------------------
  - title       : String : Title to be shown in the component.
  - icon        : Object : Icon to be shown as prefix to the title.
  - image       : String : Image to be shown as prefix to the title. Shown only if icon prop is omitted.
  - iconColor   : String : Color of the icon.
  - description : String : Title subtext. This is not implemented yet.

|   TODO
------------------------------------------------------------------------------------------------------------
  - Back button implementation
  - Description design not available so it is not finished yet.
  - Action button on the right
  - Action slot on the right for custom buttons

-->


<template>
  <div
    class="page-title flex flex-align-center"
    :style="imageCssVars">
    <div
      class="logo-wrapper" >
      <SBIcon
        v-if="icon"
        :icon="icon"
        :color="iconColor"
        :size="26"/>
      <div
        v-else
        class="image-wrapper" />
    </div>
    {{ title }}
  </div>
</template>

<script>
import SBIcon from '@/components/common/Icon';
import SBColors from '@/helpers/lists/colors';

export default {
  name: 'PageTitle',
  components: {
    SBIcon,
  },
  props: {
    title: {
      type: String,
      required: true,
      default: '',
    },
    image: {
      type: String,
      required: false,
      default: null,
    },
    icon: {
      type: Object,
      required: false,
      default: null,
    },
    iconColor: {
      type: String,
      required: false,
      default: null,
    },
    description: {
      type: String,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      SBColors,
    };
  },
  computed: {
    imageCssVars() {
      return {
        '--background-image': `url(${this.iconData})`,
      };
    },
    iconData() {
      // NOTE: For some reason it has to be done like this from the computed. if we add "@/" directly on image prop then the require fails.
      // eslint-disable-next-line
      return this.image ? (this.image.startsWith('http') ? this.image : require(`@/${this.image}`)) : null;
    },
  },
};
</script>

<style lang="scss" scoped>
.logo-wrapper {
  width: 24px;
  height: 24px;
  padding: 0;
  margin: 0 8px 0 0;
  border: none;
  box-shadow: none;

  .image-wrapper {
    width: 100%;
    height: 100%;
    background-image: var(--background-image);
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
  }
}

.page-title {
  font-size: 22px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  text-align: left;
  color: #141c20;
  margin: 35px 0;
}
</style>
